// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"278":"56e90ef0","329":"6cd24740","602":"e451c234","922":"de64c3e3"}[chunkId] + ".chunk.js";
};